import { MonthlyStats } from '../../types/property';

export const calculateMonthlyStats = (data: any): MonthlyStats => ({
  id: data.id,
  propertyId: data.property_id,
  year: data.year,
  month: data.month,
  revenue: Number(data.revenue),
  cleaningCosts: Number(data.cleaning_costs),
  inmohostCosts: Number(data.inmohost_costs),
  profit: Number(data.profit),
  occupancyRate: Number(data.occupancy_rate),
  reservations: Number(data.reservations),
  averageNightPrice: Number(data.average_night_price),
  averageStayDuration: Number(data.average_stay_duration),
  created_at: data.created_at
});

export const calculatePropertyStats = (monthlyStats: any[]) => {
  const totals = monthlyStats.reduce((acc, stat) => ({
    revenue: acc.revenue + Number(stat.revenue || 0),
    cleaning_costs: acc.cleaning_costs + Number(stat.cleaning_costs || 0),
    inmohost_costs: acc.inmohost_costs + Number(stat.inmohost_costs || 0),
    profit: acc.profit + Number(stat.profit || 0),
    occupancy_rate: acc.occupancy_rate + Number(stat.occupancy_rate || 0),
    reservations: acc.reservations + Number(stat.reservations || 0),
    average_night_price: acc.average_night_price + Number(stat.average_night_price || 0),
    average_stay_duration: acc.average_stay_duration + Number(stat.average_stay_duration || 0)
  }), {
    revenue: 0,
    cleaning_costs: 0,
    inmohost_costs: 0,
    profit: 0,
    occupancy_rate: 0,
    reservations: 0,
    average_night_price: 0,
    average_stay_duration: 0
  });

  const monthCount = monthlyStats.length || 1;

  return {
    revenue: Math.round(totals.revenue),
    cleaning_costs: Math.round(totals.cleaning_costs),
    inmohost_costs: Math.round(totals.inmohost_costs),
    profit: Math.round(totals.profit),
    occupancy_rate: Math.round(totals.occupancy_rate / monthCount),
    reservations: totals.reservations,
    average_night_price: Math.round(totals.average_night_price / monthCount),
    average_stay_duration: Math.round(totals.average_stay_duration / monthCount)
  };
};